(() => {
  'use strict';
  if (window.ujHomeInitialized) return;
  window.ujHomeInitialized = true;
  const root = () => document.querySelector('.ujack-home');
  const query = s => root()?.querySelector(s);
  let previousOverflow = null;
  const closeMenu = (focus = false) => {
    const menu = query('#uj-mobile-menu'), button = query('#uj-menu-open');
    if (previousOverflow !== null) { document.body.style.overflow = previousOverflow; previousOverflow = null; }
    if (!menu || !button) return;
    const wasOpen = !menu.hidden;
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'メニューを開く');
    if (previousOverflow !== null) { document.body.style.overflow = previousOverflow; previousOverflow = null; }
    if (focus && wasOpen) button.focus();
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
  }, {threshold:.12}) : null;
  const initialize = () => {
    const home = root(); if (!home) return;
    home.classList.add('uj-initialized');
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode && observer) {
      home.classList.add('uj-motion-ready'); home.querySelectorAll('.reveal:not(.visible)').forEach(e => observer.observe(e));
    } else home.querySelectorAll('.reveal').forEach(e => e.classList.add('visible'));
    query('#uj-header')?.classList.toggle('scrolled', scrollY > 50);
  };
  document.addEventListener('click', e => {
    const home = root(); if (!home || !(e.target instanceof Element) || !home.contains(e.target)) return;
    const el = e.target;
    if (el.closest('#uj-menu-open')) {
      const menu = query('#uj-mobile-menu'), button = query('#uj-menu-open');
      if (!menu.hidden) closeMenu(); else {
        previousOverflow = document.body.style.overflow;
        menu.hidden = false; button.setAttribute('aria-expanded','true'); button.setAttribute('aria-label','メニューを閉じる');
        document.body.style.overflow = 'hidden'; menu.querySelector('a')?.focus();
      }
    }
    if (el.closest('#uj-mobile-menu a')) closeMenu();
    if (el.closest('#uj-search-open')) { closeMenu(); query('#uj-search-dialog')?.showModal(); query('#uj-query')?.focus(); }
    if (el.closest('#uj-search-close')) query('#uj-search-dialog')?.close();
    if (el.matches('#uj-search-dialog')) {
      const r=el.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) el.close();
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeMenu(true); query('#uj-search-dialog')?.close(); }
    const menu=query('#uj-mobile-menu');
    if(e.key==='Tab' && menu && !menu.hidden){
      const items=[query('#uj-menu-open'),...menu.querySelectorAll('a[href]')].filter(Boolean);
      if(e.shiftKey && document.activeElement===items[0]){e.preventDefault();items.at(-1).focus();}
      else if(!e.shiftKey && document.activeElement===items.at(-1)){e.preventDefault();items[0].focus();}
    }
  });
  addEventListener('scroll',()=>query('#uj-header')?.classList.toggle('scrolled',scrollY>50),{passive:true});
  addEventListener('resize',()=>{if(innerWidth>600) closeMenu();});
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',e=>{
    e.target.querySelectorAll('.reveal').forEach(el=>observer?.unobserve(el));
    if(e.target.querySelector('#uj-menu-open'))closeMenu();
  });
  initialize();
})();
